import { Language } from '@/types/language'

export class AccountPreferences {
  constructor(init: Partial<AccountPreferences> = {}) {
    this.language = init.language || 'en'
  }

  language: Language
}
